export const getDataLayer = () => {
    if (!('dataLayer' in window)) {
        return [];
    }
    return window.dataLayer;
};
//# sourceMappingURL=dataLayer.js.map